<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from 'echarts';
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val, this.unit, this.min, this.max)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData, this.unit, this.min, this.max)
    },
    setOptions({ xData, yData } = {}, unit = '', min = null, max = null) {
      this.chart.setOption({
        color: ['#C59CD3', '#00DDFF', '#FF0087', '#FC7113', '#FFF117', '#80FFA5', '#EAFFE6'],
        // backgroundColor: 'transparent',
        title: {
          text: this.title,
          left: 10,
          textStyle: {
            color: '#6ab8ff',
            fontWeight: 'bold',
            fontSize: 17,
            lineHeight: 24
          },
          padding: 0
        },
        xAxis: {
          data: xData,
          // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#aab6e4',
            fontSize: 14
          },
          axisLine: {
            show: false
          }
        },
        grid: {
          left: 10,
          right: 10,
          bottom: 0,
          top: 45,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10],
          // formatter: '照片数：{c}<br />时间：{b}'
          formatter: function (params) {
            // console.log(params)
            // params 是一个数组，包含了多个 tooltip 项
            var res = params[0].name + '<br/>';
            for (var i = 0, l = params.length; i < l; i++) {
              if(params[i].value === undefined) {
                res += params[i].marker + params[i].seriesName + ' : -<br/>';
              } else {
                res += params[i].marker + params[i].seriesName + ' : ' + params[i].value + unit + '<br/>'
              }
            }
            return res;
          }
        },
        yAxis: {
          type: 'value',
          min,
          max,
          axisTick: {
            show: false
          },
          minInterval: 1,
          axisLabel: {
            color: '#aab6e4',
            fontSize: 14
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        legend: {
          // data: ['expected'],
          // show: false
          // bottom: 0,
          top: 0,
          // left: 'center',
          right: 5,
          // itemHeight: 10,
          textStyle: {
            color: '#aab6e4',
            fontSize: 14,
          },
          inactiveColor: '#4f556c'
        },
        series: yData
        // series: [
        //   {
        //     name: 'Line 1',
        //     type: 'line',
        //     stack: 'Total',
        //     smooth: true,
        //     lineStyle: {
        //       width: 0
        //     },
        //     showSymbol: false,
        //     areaStyle: {
        //       opacity: 0.8,
        //       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //         {
        //           offset: 0,
        //           color: 'rgb(128, 255, 165)'
        //         },
        //         {
        //           offset: 1,
        //           color: 'rgb(1, 191, 236)'
        //         }
        //       ])
        //     },
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [140, 232, 101, 264, 90, 340, 250]
        //   },
        //   {
        //     name: 'Line 2',
        //     type: 'line',
        //     stack: 'Total',
        //     smooth: true,
        //     lineStyle: {
        //       width: 0
        //     },
        //     showSymbol: false,
        //     areaStyle: {
        //       opacity: 0.8,
        //       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //         {
        //           offset: 0,
        //           color: 'rgb(0, 221, 255)'
        //         },
        //         {
        //           offset: 1,
        //           color: 'rgb(77, 119, 255)'
        //         }
        //       ])
        //     },
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [120, 282, 111, 234, 220, 340, 310]
        //   },
        //   {
        //     name: 'Line 3',
        //     type: 'line',
        //     stack: 'Total',
        //     smooth: true,
        //     lineStyle: {
        //       width: 0
        //     },
        //     showSymbol: false,
        //     areaStyle: {
        //       opacity: 0.8,
        //       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //         {
        //           offset: 0,
        //           color: 'rgb(55, 162, 255)'
        //         },
        //         {
        //           offset: 1,
        //           color: 'rgb(116, 21, 219)'
        //         }
        //       ])
        //     },
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [320, 132, 201, 334, 190, 130, 220]
        //   },
        //   {
        //     name: 'Line 4',
        //     type: 'line',
        //     stack: 'Total',
        //     smooth: true,
        //     lineStyle: {
        //       width: 0
        //     },
        //     showSymbol: false,
        //     areaStyle: {
        //       opacity: 0.8,
        //       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //         {
        //           offset: 0,
        //           color: 'rgb(255, 0, 135)'
        //         },
        //         {
        //           offset: 1,
        //           color: 'rgb(135, 0, 157)'
        //         }
        //       ])
        //     },
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [220, 402, 231, 134, 190, 230, 120]
        //   },
        //   {
        //     name: 'Line 5',
        //     type: 'line',
        //     stack: 'Total',
        //     smooth: true,
        //     lineStyle: {
        //       width: 0
        //     },
        //     showSymbol: false,
        //     label: {
        //       show: true,
        //       position: 'top'
        //     },
        //     areaStyle: {
        //       opacity: 0.8,
        //       color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //         {
        //           offset: 0,
        //           color: 'rgb(255, 191, 0)'
        //         },
        //         {
        //           offset: 1,
        //           color: 'rgb(224, 62, 76)'
        //         }
        //       ])
        //     },
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [220, 302, 181, 234, 210, 290, 150]
        //   }
        // ]
      })
    }
  }
}
</script>